import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const googleMapsCva = cva(undefined, {
  variants: {
    width: {
      'w-1/6': ['md:w-1/6'],
      'w-1/4': ['md:w-1/4'],
      'w-1/3': ['md:w-1/3'],
      'w-1/2': ['md:w-1/2'],
      'w-2/3': ['md:w-2/3'],
      'w-full': [''],
    },
    desktopHeight: {
      'h-160px': ['md:h-40 md:aspect-auto'],
      'h-208px': ['md:h-52 md:aspect-auto'],
      'h-256px': ['md:h-64 md:aspect-auto'],
      'h-320px': ['md:h-80 md:aspect-auto'],
      'h-384px': ['md:h-96 md:aspect-auto'],
      'h-25%': ['md:h-[25dvh] md:aspect-auto'],
      'h-33%': ['md:h-[33dvh] md:aspect-auto'],
      'h-50%': ['md:h-[50dvh] md:aspect-auto'],
      'h-66%': ['md:h-[66dvh] md:aspect-auto'],
      'h-75%': ['md:h-[75dvh] md:aspect-auto'],
      'h-100%': ['md:h-dvh md:aspect-auto'],
    },
    aspectRatio: {
      'ratio-16:9': ['aspect-[1.77]'],
      'ratio-4:3': ['aspect-[1.3]'],
    },
    alignment: {
      left: ['justify-start text-left'],
      center: ['justify-center text-center'],
      right: ['justify-end text-right'],
    },
  },
})

export type GoogleMapsProps = VariantProps<typeof googleMapsCva>
